import React from "react";

const ValueProps: React.FC = () => {
  return (
    <section className="container values">
      <h2>Why JobLens360?</h2>
      <div className="values-grid">
        <div className="value-card">
          <h3>Honest analysis</h3>
          <p>No buzzword lingo. We highlight what matters and call out vague or unrealistic requirements.</p>
        </div>
        <div className="value-card">
          <h3>Time saver</h3>
          <p>Instant scan of any job description—skip the skim, get to the insight.</p>
        </div>
        <div className="value-card">
          <h3>Actionable</h3>
          <p>Truth-preserving résumé tips: reorder, rephrase, quantify—without crossing the line.</p>
        </div>
      </div>
      <div className="mission">
        <p><strong>Our mission:</strong> level the playing field for job seekers with clarity, not buzzwords.</p>
      </div>
    </section>
  );
};

export default ValueProps;
